import type * as React from "react";
import styles from "./CaretToggle.module.scss";
import { CaretRightIcon } from "../../../assets/icons/CaretRightIcon";
import classNames from "classnames";

export const CaretToggle = ({
  expanded,
  className,
  onClick,
  label,
}: {
  onClick: (e: React.MouseEvent<HTMLElement>) => void;
  expanded: boolean;
  className?: string;
  /** Overrides the default "Expand row" / "Collapse row" accessible name. */
  label?: string;
}) => (
  // An SVG with a click handler is invisible to the keyboard and to assistive tech, and
  // this is the only way to reach an expanded row's content - so it carries the button
  // role, name and key handling that a <button> would have given for free.
  <CaretRightIcon
    role="button"
    tabIndex={0}
    aria-expanded={expanded}
    aria-label={label ?? (expanded ? "Collapse row" : "Expand row")}
    onClick={onClick}
    onKeyDown={(e: React.KeyboardEvent<HTMLElement>) => {
      if (e.key !== "Enter" && e.key !== " ") return;
      // Space would otherwise scroll the page out from under the row being opened.
      e.preventDefault();
      onClick(e as unknown as React.MouseEvent<HTMLElement>);
    }}
    className={classNames(styles.caret, className, {
      [styles.expanded]: expanded,
    })}
  />
);
